import React, { Component } from 'react';
//components

//styles
import './scss/header.scss';
import poalim_logo from "../../Static/images/poalim_logo.png";
import logo_ynet from "../../Static/images/logo_ynet.png";
import ydiot_logo from "../../Static/images/ydiot_logo.png";


class Header extends Component {
  render() {
    return (
        <header id="header-container">
            <ul id="flex-container">
                <li>
                    <img src={ydiot_logo} alt="ידיעות אחרונות"/>
                </li>
                <li className="logo_ynet">
                    <img src={logo_ynet} alt="ynet"/>
                </li>
                <li>
                    <img src={poalim_logo} alt="בנק הפועלים"/>
                </li>
            </ul>
        </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js